// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"35":"70e77373","689":"9395fe91"}[chunkId] + ".js";
};